
import { Component, Vue } from 'nuxt-property-decorator';
import TextFieldBig from '~/components/ui/TextFieldBig.vue';
import Column from '~/components/ui/Column.vue';
import ContextMenuHeaderFlashy from '~/components/dialogs/ui/ContextMenuHeaderFlashy.vue';
import ActionButtonModel from '~/models/ActionButtonModel';
import ActionButton from '~/components/layout/footer/ActionButton.vue';
import MutantContextMenu from '~/components/ui/MutantContextMenu.vue';
import { ContextMenuType } from '~/store/context/state';
import ProgressCircleAnimating from '~/components/ui/progress/ProgressCircleAnimating.vue';

@Component({
  components: {
    ActionButton,
    MutantContextMenu,
    ContextMenuHeaderFlashy,
    Column,
    TextFieldBig,
    ProgressCircleAnimating,
  },
})
export default class FeedbackContextMenu extends Vue {
  public message: string = '';
  public responseMessage: string = '';
  public isProcessing: boolean = false;

  public requestButton: ActionButtonModel = {
    name: () => 'SEND',
    action: async () => {
      await this.sendFeedback();
    },
    isHighlighted: false,
    key: 'send-feedback',
  };

  public get messageEmpty(): boolean {
    return this.message.length === 0;
  }

  public async sendFeedback() {
    try {
      this.isProcessing = true;
      await this.$api.post('/users/feedback', { message: this.message });
      this.responseMessage = 'Your feedback has been sent. Thank you!';
    } catch (e) {
      this.responseMessage = 'Your feedback could not be send. Try again later.';
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 900);
      setTimeout(() => {
        this.close();
      }, 4000);
    }
  }

  public changeValue(text: string) {
    this.message = text;
  }

  public close() {
    this.$store.dispatch('context/closeMenu', ContextMenuType.SEND_FEEDBACK);
  }
};
